import { render, staticRenderFns } from "./TagCloud.vue?vue&type=template&id=ae060f08&"
import script from "./TagCloud.vue?vue&type=script&lang=js&"
export * from "./TagCloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports